import { render, staticRenderFns } from "./FillInTheBlanks.vue?vue&type=template&id=9f918482&scoped=true&"
import script from "./FillInTheBlanks.vue?vue&type=script&lang=js&"
export * from "./FillInTheBlanks.vue?vue&type=script&lang=js&"
import style0 from "./FillInTheBlanks.vue?vue&type=style&index=0&id=9f918482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f918482",
  null
  
)

export default component.exports